import { AllInfluencers } from 'components/admin/AllInfluencers';
import { CampaignDetailAdmin } from 'components/admin/CampaignDetailAdmin';
import { Campaigns } from 'components/admin/Campaigns';
import { CampaignsIssues } from 'components/admin/CampaignsIssues';
import { Comissions } from 'components/admin/Comissions';
import { CreateCampaign } from 'components/admin/CreateCampaign';
import { CreateComissions } from 'components/admin/CreateComissions';
import { GlamqueenCoupon } from 'components/admin/GlamqueenCoupon';
import { DuvidasGlampartnersAdmin } from 'components/admin/DuvidasGlampartnersAdmin';
import { DivulgacaoGlambox } from 'components/glampartners/DivulgacaoGlambox';
import { DivulgacaoGlamshop } from 'components/glampartners/DivulgacaoGlamshop';
import { GlampartnerData } from 'components/person/GlampartnerData';
import { Elements } from 'views/development/Elements';
import { LegacyProduto } from 'views/open/LegacyProduto';
import { Login } from 'views/open/Login';
import { Register } from 'views/open/Register';
import { ResetPassword } from 'views/open/ResetPassword';
import { Page404 } from 'views/pages/404';
import { Assinatura } from 'views/pages/Assinatura';
import { Assinaturas } from 'views/pages/Assinaturas';
import { Beneficios } from 'views/pages/Beneficios';
import { Caixinha } from 'views/pages/Caixinha';
import { ChamaAsAmigas } from 'views/pages/ChamaAsAmigas';
import { Conteudo } from 'views/pages/Conteudo';
import { Convite } from 'views/pages/Convite';
import { CookieMagic } from 'views/pages/CookieMagic';
import { Curso } from 'views/pages/Curso';
import { CursosOnline } from 'views/pages/CursosOnline';
import { DadosPessoais } from 'views/pages/DadosPessoais';
import { DuvidasGlampartners } from 'views/pages/DuvidasGlampartners';
import { Eventos } from 'views/pages/Eventos';
import { Faq } from 'views/pages/Faq';
import { Feedback } from 'views/pages/Feedback';
import { FeedbackPage } from 'views/pages/FeedbackPage';
import { GanheMaisGlampoints } from 'views/pages/GanheMaisGlampoints';
import { GlamMag } from 'views/pages/GlamMag';
import { GlampartnerFaq } from 'views/pages/GlampartnerFaq';
import { GlamPoints } from 'views/pages/GlamPoints';
import { Home } from 'views/pages/Home';
import { InfluencerPayment } from 'views/pages/InfluencerPayment';
import { InfluencerResults } from 'views/pages/InfluencerResults';
import { Logout } from 'views/pages/Logout';
import { MelhoreSeusPosts } from 'views/pages/MelhoreSeusPosts';
import { ParticiparCampanhasMarcas } from 'views/pages/ParticiparCampanhasMarcas';
import { PortalGlampartners } from 'views/pages/PortalGlampartners';
import { Privacidade } from 'views/pages/Privacidade';
import { Produto } from 'views/pages/Produto';
import { Produtos } from 'views/pages/Produtos';
import { RedesSociais } from 'views/pages/RedesSociais';
import { RegisterInstagram } from 'views/pages/RegisterInstagram';
import { Registrar } from 'views/pages/Registrar';
import { Regras } from 'views/pages/Regras';
import { SobreGlamClub } from 'views/pages/SobreGlamClub';
import { Termos } from 'views/pages/Termos';
import { TermosGp } from 'views/pages/TermosGp';
import { PIS } from 'views/pages/PIS';
import { PlanoDeDesenvolvimento } from 'views/pages/PlanoDeDesenvolvimento';
import { PerfilDeBeleza } from 'views/pages/PerfilDeBeleza';
import { GlamstarSobre } from 'views/pages/GlamstarChallenge/Sobre';
import { GlamstarChallenges } from 'views/pages/GlamstarChallenge/Challenges';
import { GlamstarChallengeDetail } from 'views/pages/GlamstarChallenge/ChallengeDetail';
import { GlamstarChallenge5 } from 'views/pages/GlamstarChallenge/Challenge5';
import { GlamstarChallangeForm } from 'views/pages/GlamstarChallenge/ChallangeForm';
import { OldChallenges } from 'views/pages/GlamstarChallenge/OldChallenges';

export const Routes = {};

// Rotas livres
// ----------------------------------------------------------------------
Routes.open = [
  {
    path: '/registrar',
    component: Register,
    exact: true,
  },
  {
    path: '/recuperar-senha',
    component: ResetPassword,
    exact: true,
  },
  {
    path: '/produtos',
    component: Login,
    exact: true,
  },
  {
    path: '/produtos/:productId',
    component: LegacyProduto,
    exact: true,
  },
  {
    path: '/produtos/:productId/:productVariantId?',
    component: LegacyProduto,
    exact: true,
  },
  {
    path: '/produtos/:productId/:productVariantId/:productSlug?',
    component: LegacyProduto,
    exact: true,
  },
  // {
  //   path: "/feedback",
  //   component: OpenFeedback,
  //   exact: true
  // },
  // {
  //   path: "/feedback/produto/:productId?",
  //   component: OpenFeedback,
  //   exact: true
  // },
  // {
  //   path: "/elements",
  //   component: Elements,
  //   exact: true
  // },
  {
    component: Login,
  },
];

// Rotas Autenticadas
// ----------------------------------------------------------------------
Routes.auth = [
  {
    path: '/',
    component: Home,
    exact: true,
  },
  {
    path: '/edicoes',
    component: Caixinha,
    exact: true,
  },
  // {
  //   path: "/home",
  //   component: Home,
  //   exact: true
  // },
  // {
  //   path: "/default",
  //   component: Default,
  //   exact: true
  // },
  {
    path: '/beneficios',
    component: Beneficios,
    exact: true,
  },
  {
    path: '/feedback',
    component: Feedback,
    exact: true,
  },
  {
    path: '/assinatura',
    component: Assinatura,
    exact: true,
  },
  // {
  //   path: "/assinatura/:subscriberId",
  //   component: Assinatura,
  //   exact: true
  // },
  {
    path: '/dados-pessoais/:tab',
    component: DadosPessoais,
    exact: true,
  },
  {
    path: '/dados-pessoais',
    component: DadosPessoais,
    exact: true,
  },

  {
    path: '/perfil-de-beleza',
    component: PerfilDeBeleza,
    exact: true,
  },
  // {
  //   path: "/perfil-de-beleza/obrigada",
  //   component: PerfilDeBelezaObrigada,
  //   exact: true
  // },
  {
    path: '/sobre-o-glamclub',
    component: SobreGlamClub,
    exact: true,
  },
  {
    path: '/produtos/:page?',
    component: Produtos,
    exact: true,
  },
  {
    path: '/glampoints',
    component: GlamPoints,
    exact: true,
  },
  {
    path: '/chama-as-amigas/:subPage?',
    component: ChamaAsAmigas,
    exact: true,
  },
  {
    path: '/eventos',
    component: Eventos,
    exact: true,
  },
  {
    path: '/regras',
    component: Regras,
    exact: true,
  },
  // {
  //   path: "/influenciadores",
  //   component: Influenciadores,
  //   exact: true
  // },
  {
    path: '/conteudo',
    component: Conteudo,
    exact: true,
  },
  {
    path: '/cursos-online/:tab',
    component: CursosOnline,
    exact: true,
  },
  {
    path: '/cursos-online',
    component: CursosOnline,
    exact: true,
  },
  {
    path: '/cursos-online/:slug/:key?',
    component: Curso,
    exact: true,
  },

  {
    path: '/mag',
    component: GlamMag,
    exact: true,
  },

  {
    path: '/faq',
    component: Faq,
    exact: true,
  },
  {
    path: '/glampartner/dados-pessoais',
    component: DadosPessoais,
    exact: true,
  },
  {
    path: '/glampartner/redes-sociais',
    component: RedesSociais,
    exact: true,
  },
  {
    path: '/glampartner/dados-financeiros',
    component: GlampartnerData,
    exact: true,
  },
  {
    path: '/glampartner/faq',
    component: GlampartnerFaq,
    exact: true,
  },
  {
    path: '/glampartner/publi',
    component: ParticiparCampanhasMarcas,
    exact: true,
  },
  {
    path: '/glampartner/dados-pessoais/:tab?',
    component: DadosPessoais,
    exact: true,
  },
  {
    path: '/glampartner/dados-pessoais',
    component: DadosPessoais,
    exact: true,
  },
  {
    path: '/glampartner/glamstar/sobre',
    component: GlamstarSobre,
    exact: true,
  },
  {
    path: '/glampartner/glamstar/desafios',
    component: GlamstarChallenges,
    exact: true,
  },
  {
    path: '/glampartner/glamstar/desafio/:id',
    component: GlamstarChallengeDetail,
    exact: true,
  },
  {
    path: '/glampartner/glamstar/desafio/5/:id',
    component: GlamstarChallenge5,
    exact: true,
  },
  {
    path: '/glampartner/glamstar/desafio/oldchallenges/:id',
    component: OldChallenges,
    exact: true,
  },
  {
    path: '/glampartner/glamstar/desafio/form/:id',
    component: GlamstarChallangeForm,
    exact: true,
  },
  {
    path: '/glampartner/dados-pessoais',
    component: DadosPessoais,
    exact: true,
  },
  {
    path: '/privacidade',
    component: Privacidade,
    exact: true,
  },
  {
    path: '/termos',
    component: TermosGp,
    exact: true,
  },
  {
    path: '/glampartner/termos',
    component: TermosGp,
    exact: true,
  },
  {
    path: '/glampartner/resultados',
    component: InfluencerResults,
    exact: true,
  },
  {
    path: '/glampartner/assinaturas/:tab?',
    component: DivulgacaoGlambox,
    exact: true,
  },
  {
    path: '/glampartner/assinaturas',
    component: DivulgacaoGlambox,
    exact: true,
  },
  {
    path: '/glampartner/produtos',
    component: DivulgacaoGlamshop,
    exact: true,
  },
  {
    path: '/glampartner/duvidas',
    component: DuvidasGlampartners,
    exact: true,
  },
  {
    path: '/glampartner/plano-de-desenvolvimento',
    component: PlanoDeDesenvolvimento,
    exact: true,
  },
  {
    path: '/glampartner/melhore-seus-posts',
    component: MelhoreSeusPosts,
    exact: true,
  },
  {
    path: '/glampartner/pis',
    component: PIS,
    exact: true,
  },
  {
    path: '/logout',
    component: Logout,
    exact: true,
  },

  {
    path: '/glampartner',
    component: PortalGlampartners,
    exact: true,
  },
  {
    path: '/magica-do-cookie',
    component: CookieMagic,
    exact: true,
  },
  // {
  //   path: "/produto/:productId/:productVariantId?",
  //   component: Produto,
  //   exact: true
  // },
  {
    path: '/produto/:productId/:productVariantId/:productVariantName?',
    component: Produto,
    exact: true,
  },
  // {
  //   path: "/produtos/:productId/:productVariantId?",
  //   component: Produto,
  //   exact: true
  // },
  {
    path: '/produtos/:productId/:productVariantId/:productVariantName?',
    component: Produto,
    exact: true,
  },
  // {
  //   path: "/debug",
  //   component: Debug,
  //   exact: true
  // },
  {
    path: '/assinaturas/:subscriberId',
    component: Assinaturas,
    exact: true,
  },
  {
    path: '/convite/:personInviterId?',
    component: Convite,
    exact: true,
  },
  /*
  {
    path: "/assinaturas",
    component: Assinaturas,
    exact: true
  },

   */
  {
    path: '/elements',
    component: Elements,
    exact: true,
  },
  {
    path: '/feedback',
    component: FeedbackPage,
    exact: true,
  },
  {
    path: '/feedback/produto/:productId?',
    component: FeedbackPage,
    exact: true,
  },
  {
    path: '/feedback/form/:formId?',
    component: FeedbackPage,
    exact: true,
  },
  {
    path: '/register-instagram',
    component: RegisterInstagram,
    exact: true,
  },
  {
    path: '/ganhe-mais-glampoints',
    component: GanheMaisGlampoints,
    exact: true,
  },
  {
    path: '/registrar',
    component: Registrar,
    exact: true,
  },
  {
    path: '/admin/comissions',
    component: Comissions,
    exact: true,
  },
  {
    path: '/admin/comissions/create',
    component: CreateComissions,
    exact: true,
  },
  {
    path: '/admin/payments',
    component: InfluencerPayment,
    exact: true,
  },
  {
    path: '/admin/influencers',
    component: AllInfluencers,
    exact: true,
  },
  {
    path: '/admin/campaigns/issues',
    component: CampaignsIssues,
    exact: true,
  },
  {
    path: '/admin/duvidas',
    component: DuvidasGlampartnersAdmin,
    exact: true,
  },
  {
    path: '/admin/campaigns/:page',
    component: Campaigns,
    exact: true,
  },

  {
    path: '/admin/campaigns',
    component: Campaigns,
    exact: true,
  },

  {
    path: '/admin/campaign/create',
    component: CreateCampaign,
    exact: true,
  },
  {
    path: '/admin/campaign/:campaignId',
    component: CampaignDetailAdmin,
    exact: true,
  },
  {
    path: '/admin/glamqueen-coupon',
    component: GlamqueenCoupon,
    exact: true,
  },
  {
    //path: "/elements",
    component: Page404,
    //exact: true
  },
];

//
// ----------------------------------------------------------------------
